import React, {ReactElement} from 'react';
import {IElementArrowV2} from '../../../incase-domain/elements/shapes/arrowV2';
import {usePresScaleContext} from '../../../context/PresScaleContext';
import {asymptoticScale} from '../../../utils/math.utils';

interface ArrowElementV2Props {
    element: IElementArrowV2;
    startPointPx?: {x: number; y: number};
    endPointPx?: {x: number; y: number};
}

function ArrowElementV2({element, startPointPx, endPointPx}: ArrowElementV2Props): ReactElement {
    const {color, size, startPoint, endPoint, id} = element;
    const strokeColor = color || 'black';
    const strokeWidth = size || 0.0625;
    const {transformPointFromFraction, workspaceSize} = usePresScaleContext();

    const start = startPointPx ?? transformPointFromFraction(startPoint);
    const end = endPointPx ?? transformPointFromFraction(endPoint);
    const viewBox = workspaceSize.width && workspaceSize.height ? `0 0 ${workspaceSize.width} ${workspaceSize.height}` : undefined;
    const markerId = `arrowhead-${id}`;

    const markerScale = asymptoticScale(strokeWidth, 1, 5, 2);
    const markerSize = 14 * markerScale;
    const polylinePoints = `0,0 ${markerSize},${markerSize / 2} 0,${markerSize}`;

    return (
        <svg style={{height: '100%', width: '100%'}} viewBox={viewBox} preserveAspectRatio="none">
            <defs>
                <marker
                    id={markerId}
                    markerWidth={markerSize}
                    markerHeight={markerSize}
                    refX={markerSize}
                    refY={markerSize / 2}
                    orient="auto"
                    markerUnits="userSpaceOnUse"
                >
                    <polyline points={polylinePoints} fill="none" stroke={strokeColor} strokeWidth={`${strokeWidth}em`} />
                </marker>
            </defs>

            <line
                className="invisibleClickable"
                x1={start.x}
                y1={start.y}
                x2={end.x}
                y2={end.y}
                stroke="transparent"
                strokeWidth="1em"
                pointerEvents="stroke"
            />
            <line
                x1={start.x}
                y1={start.y}
                x2={end.x}
                y2={end.y}
                stroke={strokeColor}
                strokeWidth={`${strokeWidth}em`}
                markerEnd={`url(#${markerId})`}
            />
        </svg>
    );
}

export default ArrowElementV2;
